<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData || {});
    },
    setOptions() {
      let _this = this;
      var data = {
        name: "呼叫北极星",
        children: [
          {
            name: "晋安区人民检察院",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区政法委员会",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区公安分局",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区民政局",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区教育局",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区人力资源和社会保障局",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区妇女联合会",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "中国共青团福州市晋安区委",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "福州市晋安区工商业联合会",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区司法局",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "晋安区人民法院",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "北极星王庄街道社工站",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "北极星岳峰镇社工站",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
          {
            name: "北极星两岸社区交流中心社工站",
            children: [
              {
                name: "张三",
                value: 1,
              },
              {
                name: "李四",
                value: 1,
              },
              {
                name: "王五",
                value: 1,
              },
            ],
          },
        ],
      };

      this.chart.setOption({
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          backgroundColor:'rgba(255,255,255,1)'
        },
        series: [
          {
            type: "tree",
            data: [data],
            left: "2%",
            right: "2%",
            top: "20%",
            bottom: "20%",
            symbol: "emptyCircle",
            orient: "vertical",
            expandAndCollapse: true,
            symbolSize: 10,
            itemStyle:{
              color:_this.isbig ? "#AABEFF" : "#333"
            },
            // layout: "orthogonal",
            label: {
              position: "top",
              rotate: -90,
              verticalAlign: "middle",
              align: "right",
              fontSize: 9,
              color:_this.isbig ? "#AABEFF" : "#333"
            },
            lineStyle: {
              width: 1,
              color:_this.isbig ? "#AABEFF" : "#333"
            },
            leaves: {
              label: {
                position: "bottom",
                rotate: -90,
                verticalAlign: "middle",
                align: "left",
              },
            },
            animationDurationUpdate: 750,
          },
        ],
      });
    },
  },
};
</script>
